import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import "./UserProfile.scss";
import { UserRolesEnum } from "../../enum/enums";
import { getRoleName } from "../../utils/common";
import ResetPassword from "../../pages/resetPassword/ResetPassword";
import masterApi from "../../services/masterApi";

const UserProfile = ({closePopin,onSave }) => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const [ShowResetPasswordPopin, setShowResetPasswordPopin] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  // Initialize React Hook Form
  const { register, handleSubmit, reset } = useForm();
  const [createItemForm, setCreateItemForm] = useState({
    Files: [],
    ImageValue: null,
    Image: null,
  });
  const [isExpertiseRequired, setExpertiseRequired] = useState(true);
  const openResetPasswordPopin = () => {
    setShowResetPasswordPopin(!ShowResetPasswordPopin);
  };

  const handleViewClick = () => {
    setShowResetPasswordPopin(!ShowResetPasswordPopin);
    setIsEditing(false);
  };

  const fetchData = async () => {
    try {
      const user = await localStorage.getItem("user");
      if (user) {
        const parsedUserData = JSON.parse(user);
        if (parsedUserData?.userRole == UserRolesEnum.TECHINICIAN) {
          setExpertiseRequired(true);
        } else {
          setExpertiseRequired(false);
        }       
        const userId = parsedUserData._id;
        const response = await masterApi.getUsersById({ userId });
        const fetchedUserDetails = response?.data?.usersDetails[0];
        await setUserDetails(fetchedUserDetails);        
        // Populate form with fetched user details
        reset({
          email: fetchedUserDetails?.email || "",
          mobile: fetchedUserDetails?.mobile || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  }; 
  useEffect(() => {    
    fetchData(); 
  }, []);
  const onSubmit = async (data) => {
    // Logic to handle form submission, e.g., API call to update user details
    const userId = userDetails?._id;
    const formData = new FormData();
    formData.append("mobile", data.mobile);
    formData.append("email", data.email);    
    formData.append("image", data.image[0]);
    formData.append("userId", userId); 
    try {
      const updateResponse = await masterApi.updateUser({ userId, formData });
      const response = await masterApi.getUsersById({ userId });
      const fetchedUserDetails = response?.data?.usersDetails[0];      
      await localStorage.setItem('user', JSON.stringify(fetchedUserDetails));      
      await setIsEditing(false);
      onSave(); // Trigger the save callback  
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };
  

  const handleEditClick = () => {
    setIsEditing(true);
    setImagePreview(apiBaseUrl + userDetails?.profileImagePath);
    setShowResetPasswordPopin(false);
  };
  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };
  return (
    <div className="popIn-inner-wrapper">
      <div className="user-details">
        <div className="user">
          {isEditing ? (
            <div className="profile-img">
              <div className="uploadButton">
                {createItemForm.ImageValue && createItemForm.Image === null && (
                  <img
                    src={`data:${createItemForm.ImageValue};base64,${createItemForm.ImageValue}`}
                    alt=""
                  />
                )}
                {imagePreview == null && (
                  <div className="uploadTrigger">
                    <div className="icon">
                      <svg width="20" height="18.182" viewBox="0 0 20 18.182">
                        <path
                          id="Path_2519"
                          data-name="Path 2519"
                          d="M2.818,19.182a1.75,1.75,0,0,1-1.284-.534A1.754,1.754,0,0,1,1,17.364V6.455a1.749,1.749,0,0,1,.535-1.284,1.755,1.755,0,0,1,1.284-.535H5.682L7.364,2.818h5.455V4.636H8.159L6.5,6.455H2.818V17.364H17.364V9.182h1.818v8.182a1.822,1.822,0,0,1-1.818,1.818ZM17.364,6.455V4.636H15.545V2.818h1.818V1h1.818V2.818H21V4.636H19.182V6.455ZM10.091,16a4.072,4.072,0,0,0,4.091-4.091,4.074,4.074,0,0,0-4.091-4.091A4.075,4.075,0,0,0,6,11.909,4.074,4.074,0,0,0,10.091,16m0-1.818a2.251,2.251,0,0,1-2.273-2.273,2.251,2.251,0,0,1,2.273-2.273,2.251,2.251,0,0,1,2.273,2.273,2.251,2.251,0,0,1-2.273,2.273"
                          transform="translate(-1 -1)"
                          fill="gray"
                        />
                      </svg>
                    </div>
                  </div>
                )}

                {imagePreview && (
                  <div className="dpDisplay">
                    <img src={imagePreview} alt="Preview" />
                  </div>
                )}

                <input
                  {...register("image", { required: false })}
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    onImageChange(e);
                    register("image").onChange(e);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="user-image">
              <img
                className="user-image"
                src={apiBaseUrl + userDetails?.profileImagePath}
                alt="User"
              />
            </div>
          )}
          <div className="name">
            {userDetails?.firstName} {userDetails?.lastName}
          </div>
          <div className="position">{getRoleName(userDetails?.userRole)}</div>
        </div>
        <div className="details">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="detail-section">
              <label>User Name</label>              
                <div className="text">{userDetails?.username}</div>              
            </div>
            <div className="detail-section">              
            {isEditing ? (
                <>
                  <label>Email</label>
                  <input
                    className="edit-section"
                    type="email"
                    {...register("email")}
                  />
                </>
              ) : (
                userDetails?.email && (
                  <>
                    <label>Email</label>
                    <div className="text">{userDetails.email}</div>
                  </>
                )
              )}
            </div>
           
            <div className="detail-section">
              <label>Phone</label>
              {isEditing ? (
                <input
                  className="edit-section"
                  type="tel"
                  {...register("mobile")}
                />
              ) : (
                <div className="text">{userDetails?.mobile}</div>
              )}
            </div>
            {isExpertiseRequired && (
              <div className="detail-section">
                <label>Expertise</label>
                <div className="text">
                  {userDetails?.expertises
                    ?.map((expertise) => expertise.expertiseName)
                    .join(", ")}
                </div>
              </div>
            )}
            {isEditing && (
              <div className="action-btn">
                <button
                  type="button"
                  className="cancel secondary-btn"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="save primary-btn">
                  Save
                </button>
              </div>
            )}
          </form>
        </div>
        {!ShowResetPasswordPopin && !isEditing && (
          <div className="reset-password-btn" onClick={handleViewClick}>
            Change Password
          </div>
        )}
        {ShowResetPasswordPopin && (
          <ResetPassword closeResetPassword={handleViewClick} />
        )}
      </div>

      {!isEditing && !ShowResetPasswordPopin && (
        <div className="action-btn">
          <button className="cancel secondary-btn" onClick={closePopin}>
            Cancel
          </button>
          <button className="save primary-btn" onClick={handleEditClick}>
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
